import React from 'react';

const Divider = () => {
    return (
        <span style={{color: '#096cb4', fontWeight: '900'}}>|</span>
    )
}

export default Divider